import React, { Component } from 'react';

const ViewDocuments = () => {
	return ( <h1>View Documents</h1> );
}
 
export default ViewDocuments;